// extracted by mini-css-extract-plugin
export default {"root":"_22dQ1","small":"_31crF","normal":"_2u_D4"};